import type { ReactNode } from 'react';

export const symbol_feature_search: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M137-80q-24 0-42-18t-18-42v-590q0-24 18-42t42-18h221q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H137v590h590v-241q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v241q0 24-18 42t-42 18H137Zm627-526 111 111q9 9 9 21t-9 21q-9 9-21.5 9t-21.5-9L720-564q-21 16-46.5 24t-52.5 8q-72.5 0-123.25-50.75T447-706q0-72.5 51-123.25T621-880q72 0 123 50.75T795-706q0 26-8 52t-23 48Zm-62-19.08q33-33.09 33-81Q735-754 701.92-787q-33.09-33-81-33Q573-820 540-786.92q-33 33.09-33 81Q507-658 540.08-625q33.09 33 81 33Q669-592 702-625.08ZM137-441v301-590 258-8 39Z"
		/>
	</svg>
);
